// Constants
const POLL_INTERVAL = 4000;
const NOTIFICATION_TIMEOUT = 10000;

// Set function for polling for report PDF, PPT or Word generation progress
export function PollProgress(el, tableId) {

  let url = $(el).attr('data-url');

  if (typeof url !== 'undefined') {
    $.ajax({
      type: 'GET',
      dataType: 'application/json',
      url: url,
      complete(result) { 
        let response = JSON.parse(result.responseText);
        let record = response.record;
        let reportPdf = response.report_pdf;
        let reportPpt = response.report_ppt;
        let reportWordDoc = response.report_word_doc;
        let portfolio = response.portfolio;
        let exportRecord = response.export;

        // Update width of bar
        let width = 0;
        if (typeof reportPdf !== 'undefined') {
          width = parseFloat(reportPdf.percent_complete) * 100;
        } else if (typeof record !== 'undefined') {
          width = parseFloat(record.percent_complete) * 100;
        } else if (typeof reportPpt !== 'undefined') {
          width = parseFloat(reportPpt.percent_complete) * 100;
        } else if (typeof reportWordDoc !== 'undefined') {
          width = parseFloat(reportWordDoc.percent_complete) * 100;
        } else if (typeof portfolio !== 'undefined') {
          width = parseFloat(portfolio.percent_complete) * 100;
        } else if (typeof exportRecord !== 'undefined') {
          width = parseFloat(exportRecord.percent_complete) * 100;
        }
        
        $(el).find('#theBar').css('width', width + '%');

        if (typeof reportPdf !== 'undefined' || typeof reportPpt !== 'undefined' || typeof reportWordDoc !== 'undefined' || typeof exportRecord !== 'undefined') {
          updateNotificationCount();
        }

        // Continue polling if width not at 100%
        if (width === 100) {
          $('#' + tableId).DataTable().ajax.reload();
        } else {
          setTimeout(() => {
            PollProgress(el, tableId);
          }, POLL_INTERVAL);
        }
      }
    });
  }

}

// Function to update notification count during report generation
const updateNotificationCount = () => {
  $.ajax({
    type: "GET",
    dataType: "json",
    url: '/monitoring/notifications/unread_count',
    timeout: NOTIFICATION_TIMEOUT
  }).done((data) => {
    if (data.status === 200) {
      updateNotificationBadge(data.unread_count || 0);
    }
  }).fail((xhr, textStatus, errorThrown) => {
    console.error('Failed to update notification count:', errorThrown);
  });
};

// Helper function to handle notification badge updates
const updateNotificationBadge = (newCount) => {
  const $notificationsNav = $('#notifications_nav');
  const $countElement = $notificationsNav.find('.notifications-count');
  const currentCount = parseInt($countElement.text()) || 0;
  
  if (newCount !== currentCount) {
    // Update the count badge
    if (newCount > 0) {
      if ($countElement.hasClass('badge')) {
        $countElement.text(newCount);
      } else {
        $countElement.addClass('badge').text(newCount);
      }
    } else {
      $countElement.removeClass('badge').text('');
    }
  }
};
